
import { FC, useMemo, useState } from 'react';

import { IHasChildren } from '../../common/types/IHasChildren';
import CommonContext from '../../../contexts/data/CommonContext';


interface ICommonProviderProps extends IHasChildren { }

const CommonProvider: FC<ICommonProviderProps> = ({
    children
}) => {

    const [helpOpen, setHelpOpen] = useState<boolean>(false);
    const [mobileNavigationDrawerOpen, setMobileNavigationDrawerOpen] = useState<boolean>(false);
    
    const context = useMemo(() => {
        return {
            helpOpen: helpOpen,
            setHelpOpen: setHelpOpen,
            mobileNavigationDrawerOpen: mobileNavigationDrawerOpen,
            setMobileNavigationDrawerOpen: setMobileNavigationDrawerOpen
        };
    }, [
        helpOpen,
        setHelpOpen,
        mobileNavigationDrawerOpen,
        setMobileNavigationDrawerOpen
    ]);

    return (
        <CommonContext.Provider value={context}>
            {children}
        </CommonContext.Provider>
    )
}

export default CommonProvider;